import ChannelBox from './ChannelBox';

export default ChannelBox;
